import getCDNPath from '@/utils/shared/getCDNPath';
import getOfficialSitePath from '@/utils/shared/getOfficialSitePath';
import { IBannerDefaultConfig } from './IComponent';

export const defaultButtonConfig = {
    backgroundColor: 'var(--b_6)',
    bannerColor: '#041837',
    btnColor: '#FFFFFF'
};

export const dotClass = 'absolute xl:bottom-0 lg:bottom-0 md:bottom-0 my-24 text-center w-full z-2 sm:text-right sm:right-20 sm:my-20';

export const defaultConfig: IBannerDefaultConfig[] = [
    {
        title: '[color=red]Argus 3 <br> Pro[/color]',
        description: '[color=orange]Solar Powered, or <br> Recharg<br/>eable Battery<br > Powered${1}[/color]',
        note: '[color=red]Argus 3 Pro[/color]',
        imagePc: {
            src: getCDNPath('/wp-content/assets/banner/argus3-pro_sp-store-banner-m.jpg'),
        },
        imageMobile: {
            src: getCDNPath('/wp-content/assets/banner/argus3-pro_sp-store-banner-m.jpg'),
        },
        videoPc: getCDNPath('/wp-content/uploads/2023/02/170329211676604561.2035.mp4'),
        link: undefined,
        button: [
            {link: getOfficialSitePath('/product/argus-3-pro'), text: 'Argus 3 Pro' },
            {link: getOfficialSitePath('/product/argus-pt-pro'), text: 'Argus Pt Pro'},
            {link: getOfficialSitePath('/product/argus-2e'), text: 'Argus 2e', color: '#fff', backgroundColor: 'linear-gradient(148deg, #1E7FF2 0%, #1DC4E4 100%)'}
        ],
    },
    {
        title: 'Reolink Go Pt',
        description: 'Affordable Way to Get All-Around Smart Home Security',
        note: '',
        imagePc: {
            src: getCDNPath('/wp-content/assets/banner/reolink-go-pt-store-pc.jpg'),
        },
        imageMobile: {
            src: getCDNPath('/wp-content/assets/banner/reolink-go-pt-store-m.jpg'),
        },
        link: getOfficialSitePath('/product/reolink-go-pt'),
        button: [
            {link: getOfficialSitePath('/product/reolink-go-pt-plus'), text: 'Reolink Go Pt Plus', color: '#fff', backgroundColor: 'linear-gradient(151deg, #EB3349 0%, #F45C43 100%)'},
            {link: getOfficialSitePath('/product/reolink-go-plus'), text: 'Reolink Go Plus', color: '#fff', backgroundColor: 'linear-gradient(148deg, #1E7FF2 0%, #1DC4E4 100%)'},
        ]
    },
    {
        title: 'Reolink Duo Poe',
        description: '24/7 Stay Protected with 5MP or 4K & Easy PoE',
        note: '',
        imagePc: {
            src: getCDNPath('/wp-content/assets/banner/duo-poe-store-banner-pc.jpg'),
        },
        imageMobile: {
            src: getCDNPath('/wp-content/assets/banner/811a-store-banner-m.jpg'),
        },
        link: getOfficialSitePath('/product/reolink-duo-poe'),
        button: [
            {link: getOfficialSitePath('/product/reolink-duo-poe'), text: 'Reolink Duo Poe', color: '#fff', backgroundColor: 'linear-gradient(151deg, #EB3349 0%, #F45C43 100%)'},
            {link: getOfficialSitePath('/product/reolink-duo'), text: 'Reolink Duo', color: '#fff', backgroundColor: 'linear-gradient(148deg, #1E7FF2 0%, #1DC4E4 100%)'},
            {link: getOfficialSitePath('/product/reolink-duo-4g'), text: 'Reolink Duo 4g', color: '#fff', backgroundColor: 'linear-gradient(148deg, #1E7FF2 0%, #1DC4E4 100%)'},
            {link: getOfficialSitePath('/product/reolink-duo-wifi'), text: 'Reolink Duo Wifi', color: '#fff', backgroundColor: 'linear-gradient(148deg, #1E7FF2 0%, #1DC4E4 100%)'},
        ]
    },
    {
        title: 'Rlk8 810b4 A',
        description: 'Keep a Super HD Eye Outdoors & Indoors Using Easy Power over Ethernet Technology',
        note: '',
        imagePc: {
            src: getCDNPath('/wp-content/assets/banner/rlk8-810b4-a-stote-banner-pc.jpg'),
        },
        imageMobile: {
            src: getCDNPath('/wp-content/assets/banner/duo-poe-store-banner-m.jpg'),
        },
        link: getOfficialSitePath('/product/rlk8-810b4-a'),
        button: [
            {link: getOfficialSitePath('/product/rlk8-810b4-a'), text: 'Rlk8 810b4 A', color: '#fff', backgroundColor: 'linear-gradient(148deg, #1E7FF2 0%, #1DC4E4 100%)'},
            {link: getOfficialSitePath('/product/rlk8-410b4'), text: 'Rlk8 410b4', color: '#fff', backgroundColor: 'linear-gradient(151deg, #EB3349 0%, #F45C43 100%)'},
        ]
    }
];
